export const Facebook = () => (
   <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M12 1H9C7.67392 1 6.40215 1.52678 5.46447 2.46447C4.52678 3.40215 4 4.67392 4 6V9H1V13H4V21H8V13H11L12 9H8V6C8 5.73478 8.10536 5.48043 8.29289 5.29289C8.48043 5.10536 8.73478 5 9 5H12V1Z"
         stroke="#1E2833"
         strokeWidth="1.5"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);

export const Twitter = () => (
   <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M23 1.00999C23 1.00999 20.982 2.20199 19.86 2.53999C19.2577 1.84751 18.4573 1.35669 17.567 1.13392C16.6767 0.911155 15.7395 0.96719 14.8821 1.29445C14.0247 1.62171 13.2884 2.2044 12.773 2.96371C12.2575 3.72303 11.9877 4.62233 12 5.53999V6.53999C10.2426 6.58556 8.50127 6.19581 6.93101 5.40544C5.36074 4.61507 4.01032 3.44863 3 2.00999C3 2.00999 -1 11.01 8 15.01C5.94053 16.408 3.48716 17.1089 1 17.01C10 22.01 21 17.01 21 5.50999C21 5.23199 20.972 4.95399 20.92 4.67999C21.94 3.67399 23 1.00999 23 1.00999Z"
         stroke="#1E2833"
         strokeWidth="1.5"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);

export const Instagram = () => (
   <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         fillRule="evenodd"
         clipRule="evenodd"
         d="M7.54169 0H15.428C19.0571 0 22 2.94292 22 6.57196V14.4583C22 18.0873 19.0571 21.0303 15.428 21.0303H7.54169C3.91265 21.0303 0.969727 18.0873 0.969727 14.4583V6.57196C0.969727 2.94292 3.91265 0 7.54169 0ZM15.428 19.0587C17.9648 19.0587 20.0284 16.9951 20.0284 14.4583V6.57196C20.0284 4.03518 17.9648 1.97159 15.428 1.97159H7.54169C5.00491 1.97159 2.94131 4.03518 2.94131 6.57196V14.4583C2.94131 16.9951 5.00491 19.0587 7.54169 19.0587H15.428Z"
         fill="#1E2833"
      />
      <path
         fillRule="evenodd"
         clipRule="evenodd"
         d="M6.22729 10.5151C6.22729 7.61164 8.58137 5.25757 11.4849 5.25757C14.3884 5.25757 16.7424 7.61164 16.7424 10.5151C16.7424 13.4186 14.3884 15.7727 11.4849 15.7727C8.58137 15.7727 6.22729 13.4186 6.22729 10.5151ZM8.19888 10.5151C8.19888 12.3264 9.67363 13.8011 11.4849 13.8011C13.2961 13.8011 14.7708 12.3264 14.7708 10.5151C14.7708 8.70259 13.2961 7.22916 11.4849 7.22916C9.67363 7.22916 8.19888 8.70259 8.19888 10.5151Z"
         fill="#1E2833"
      />
      <circle cx="17.1367" cy="4.86323" r="0.700571" fill="#1E2833" />
   </svg>
);

export const SquareBoxes = () => (
   <svg
      width="120"
      height="70"
      viewBox="0 0 163 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
         position: "absolute",
         left: 0,
         top: 0,
      }}
   >
      <g opacity="0.1">
         <rect width="82" height="101" transform="matrix(-1 0 0 1 82 2)" fill="black" />
      </g>
      <g opacity="0.5">
         <rect width="81" height="99" transform="matrix(-1 0 0 1 163 -46)" fill="black" />
      </g>
   </svg>
);

export const Circles = () => (
   <svg
      width="115"
      height="110"
      viewBox="0 0 115 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
         position: "absolute",
         right: "10%",
      }}
   >
      <circle cx="23.5" cy="86.5" r="23.5" fill="white" fillOpacity="0.1" />
      <circle cx="91.5" cy="23.5" r="23.5" fill="white" fillOpacity="0.1" />
   </svg>
);

export const BackToTop = () => (
   <svg
      style={{
         position: "absolute",
         right: "10%",
         bottom: "12%",
      }}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <rect width="50" height="50" rx="25" fill="#3578E5" />
      <path
         d="M28.6333 28.3458L24.8125 24.525L20.9917 28.3458L19.8125 27.1667L24.8125 22.1667L29.8125 27.1667L28.6333 28.3458Z"
         fill="white"
      />
   </svg>
);

export const Bubble = () => (
   <svg
      width="249"
      height="183"
      viewBox="0 0 249 183"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
         position: "absolute",
         right: "10%",
      }}
   >
      <rect
         x="54"
         y="63.8174"
         width="151.634"
         height="151.634"
         rx="35"
         transform="rotate(-30 54 63.8174)"
         fill="#669FF5"
         fillOpacity="0.1"
      />
      <circle cx="23.5" cy="73.5" r="23.5" fill="#FFD167" fillOpacity="0.2" />
   </svg>
);
